import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { disposables as b } from './disposables.js';
import { match as L } from './match.js';
import { getOwnerDocument as m } from './owner.js';
var c = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map(function (e) {
  return "".concat(e, ":not([tabindex='-1'])");
}).join(",");
var M = function (n) {
    return n[n.First = 1] = "First", n[n.Previous = 2] = "Previous", n[n.Next = 4] = "Next", n[n.Last = 8] = "Last", n[n.WrapAround = 16] = "WrapAround", n[n.NoScroll = 32] = "NoScroll", n;
  }(M || {}),
  N = function (o) {
    return o[o.Error = 0] = "Error", o[o.Overflow = 1] = "Overflow", o[o.Success = 2] = "Success", o[o.Underflow = 3] = "Underflow", o;
  }(N || {}),
  F = function (t) {
    return t[t.Previous = -1] = "Previous", t[t.Next = 1] = "Next", t;
  }(F || {});
function f() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
  return e == null ? [] : Array.from(e.querySelectorAll(c)).sort(function (r, t) {
    return Math.sign((r.tabIndex || Number.MAX_SAFE_INTEGER) - (t.tabIndex || Number.MAX_SAFE_INTEGER));
  });
}
var T = function (t) {
  return t[t.Strict = 0] = "Strict", t[t.Loose = 1] = "Loose", t;
}(T || {});
function h(e) {
  var _L;
  var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var t;
  return e === ((t = m(e)) == null ? void 0 : t.body) ? !1 : L(r, (_L = {}, _defineProperty(_L, 0, function _() {
    return e.matches(c);
  }), _defineProperty(_L, 1, function _() {
    var l = e;
    for (; l !== null;) {
      if (l.matches(c)) return !0;
      l = l.parentElement;
    }
    return !1;
  }), _L));
}
function D(e) {
  var r = m(e);
  b().nextFrame(function () {
    r && !h(r.activeElement, 0) && y(e);
  });
}
var w = function (t) {
  return t[t.Keyboard = 0] = "Keyboard", t[t.Mouse = 1] = "Mouse", t;
}(w || {});
typeof window != "undefined" && typeof document != "undefined" && (document.addEventListener("keydown", function (e) {
  e.metaKey || e.altKey || e.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", function (e) {
  e.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function y(e) {
  e == null || e.focus({
    preventScroll: !0
  });
}
var S = ["textarea", "input"].join(",");
function H(e) {
  var r, t;
  return (t = (r = e == null ? void 0 : e.matches) == null ? void 0 : r.call(e, S)) != null ? t : !1;
}
function I(e) {
  var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (t) {
    return t;
  };
  return e.slice().sort(function (t, l) {
    var o = r(t),
      i = r(l);
    if (o === null || i === null) return 0;
    var n = o.compareDocumentPosition(i);
    return n & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : n & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function _(e, r) {
  return O(f(), r, {
    relativeTo: e
  });
}
function O(e, r) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref$sorted = _ref.sorted,
    t = _ref$sorted === void 0 ? !0 : _ref$sorted,
    _ref$relativeTo = _ref.relativeTo,
    l = _ref$relativeTo === void 0 ? null : _ref$relativeTo,
    _ref$skipElements = _ref.skipElements,
    o = _ref$skipElements === void 0 ? [] : _ref$skipElements;
  var i = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e.ownerDocument,
    n = Array.isArray(e) ? t ? I(e) : e : f(e);
  o.length > 0 && n.length > 1 && (n = n.filter(function (s) {
    return !o.includes(s);
  })), l = l != null ? l : i.activeElement;
  var E = function () {
      if (r & 5) return 1;
      if (r & 10) return -1;
      throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
    }(),
    x = function () {
      if (r & 1) return 0;
      if (r & 2) return Math.max(0, n.indexOf(l)) - 1;
      if (r & 4) return Math.max(0, n.indexOf(l)) + 1;
      if (r & 8) return n.length - 1;
      throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
    }(),
    p = r & 32 ? {
      preventScroll: !0
    } : {},
    d = 0,
    a = n.length,
    u;
  do {
    if (d >= a || d + a <= 0) return 0;
    var s = x + d;
    if (r & 16) s = (s + a) % a;else {
      if (s < 0) return 3;
      if (s >= a) return 1;
    }
    u = n[s], u == null || u.focus(p), d += E;
  } while (u !== i.activeElement);
  return r & 6 && H(u) && u.select(), 2;
}
export { M as Focus, N as FocusResult, T as FocusableMode, y as focusElement, _ as focusFrom, O as focusIn, f as getFocusableElements, h as isFocusableElement, D as restoreFocusIfNecessary, I as sortByDomNode };